var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-table',{attrs:{"table-top":"","headers":_vm.headers,"items":_vm.items,"paginate":"","excel-file-name":"beneficiaries-female-laborers"},scopedSlots:_vm._u([{key:"cell(cost)",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm.formatMoney(value, true))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }